import { broadcastMessage } from "@redux/modules/value/messages/messages.utils";
import { Translate } from "@redux/modules/value/translations/translations.provider";

import { ECommerceModel } from "@components/Product/ECommerce/eCommerce.types";

const isAdditionalService = (eCommerceModel: ECommerceModel) =>
    eCommerceModel.product.montageParents.length > 0;

const broadcastAddToCartNotAvailableForServiceProduct = (t: Translate) =>
    broadcastMessage({
        id: "pdp-error",
        text: t("general.message.addToCartNotAvailableForServiceProduct"),
        status: "info",
        dismissible: true,
    });

export { isAdditionalService, broadcastAddToCartNotAvailableForServiceProduct };
